import { DownloadDialog } from '@root/entities/deeplinking/download-dialog/ui/download-dialog'
import { UnsafeUrlDrawer } from '@root/entities/deeplinking/unsafe-url-dialog/ui/unsafe-url-drawer'
import { LogoutDrawer } from '@root/features/auth/logout/ui/logout-drawer'
import { BasicDepositDialog } from '@root/features/basic'
import { EditInviteCodeDrawer } from '@root/features/referral/ui/mobile/invite-code-drawer/edit-invite-code-drawer'
import { ChangeReferralCodeDrawer } from '@root/features/referral/ui/mobile/referral-drawer/change-referral-code-drawer'
import { CreateReferralCodeDrawer } from '@root/features/referral/ui/mobile/referral-drawer/create-referral-code-drawer'
import { ViewReferralCodeDrawer } from '@root/features/referral/ui/mobile/referral-drawer/view-referral-code-drawer'
import { LocalPasswordDialogController } from '@root/features/secure-storage/ui'
import { WalletProfileModal } from '@root/features/services/wallet-profile/ui'
import { TransactionDetailsDrawerController } from '@root/features/transactions/ui/mobile/transaction-details-drawer-controller'
import { ReportUserDrawer } from '@root/features/user/report'
import { AddWalletDrawer } from '@root/features/wallet'
import { CommentsDrawer } from '@root/screens/profile/ui/profile-comments-drawer'
import { ScanScreenController } from '@root/screens/scan/ui'
import { PremiumBuyDrawers } from '@root/widgets/premium/premium-payment/ui/mobile'
import { ReferralWithdrawDrawerController } from '@root/widgets/referral/referral-withdraw/ui'
import { RelationsDrawer } from '@root/widgets/relations'
import { SearchDrawerController } from '@root/widgets/search/search-drawer/ui'
import { SettingsDrawer } from '@root/widgets/settings-drawer/ui/settings-drawer'
import { SplashPointsInfoDrawer } from '@root/widgets/splash-points'
import { EditOrderDrawerController } from '@root/widgets/trade/edit-order-drawer'
import { TradeSettingsDrawerController } from '@root/widgets/trade/trade-settings/mobile/ui'
import { WalletImportDrawer } from '@root/widgets/wallet'

type Props = {}

export const MobileDialogs: React.FC<Props> = () => {
  return (
    <>
      <PremiumBuyDrawers />
      <DownloadDialog />
      <SplashPointsInfoDrawer />
      <UnsafeUrlDrawer />
      <ReportUserDrawer />
      <EditOrderDrawerController />
      <TradeSettingsDrawerController />
      <ScanScreenController />
      <LogoutDrawer />
      <RelationsDrawer />
      <CommentsDrawer />
      <SearchDrawerController />
      <WalletImportDrawer />
      <AddWalletDrawer />
      <ChangeReferralCodeDrawer />
      <CreateReferralCodeDrawer />
      <ViewReferralCodeDrawer />
      <EditInviteCodeDrawer />
      <ReferralWithdrawDrawerController />
      <SettingsDrawer />
      <LocalPasswordDialogController />
      <TransactionDetailsDrawerController />
      <BasicDepositDialog />
      <WalletProfileModal />
    </>
  )
}
